(function (window) {
  'use strict';

  function normalize(value) { return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase(); }
  function isFilterKey(key) { return /^pf_/i.test(key) && !/_and_condition(?:\[\])?$/i.test(key); }
  function filterKind(key) {
    var name = key.replace(/\[\]$/, '').replace(/^pf_(?:opt|t|v|p|st|m|c|r)_/i, '').toLowerCase();
    if (/^(size|sizes)$/.test(name)) return 'size';
    if (/^(color|colour|colors|colours)$/.test(name)) return 'color';
    if (/availability|stock_status|^stock$/.test(name)) return 'availability';
    if (/vendor|brand/.test(name)) return 'brand';
    if (/price/.test(name)) return 'price';
    if (/main.?categor/.test(name)) return 'mainCategories';
    if (/categor/.test(name)) return 'categories';
    return '';
  }
  function titleKind(title) {
    var value = normalize(title).replace(/^filter by:\s*/, '').replace(/^التصفية حسب:\s*/, '');
    var titles = {
      size: 'size', sizes: 'size', 'المقاس': 'size', 'المقاسات': 'size',
      color: 'color', colour: 'color', 'اللون': 'color', 'الألوان': 'color',
      availability: 'availability', 'stock status': 'availability', 'التوفر': 'availability', 'حالة المخزون': 'availability',
      brand: 'brand', brands: 'brand', vendor: 'brand', 'العلامة التجارية': 'brand',
      price: 'price', 'السعر': 'price', 'main categories': 'mainCategories', 'الفئات الرئيسية': 'mainCategories',
      categories: 'categories', 'الفئات': 'categories'
    };
    return titles[value] || '';
  }
  function labelFor(key, ar) {
    var labels = {
      size: ['Size', 'المقاس'], color: ['Color', 'اللون'], availability: ['Availability', 'التوفر'],
      brand: ['Brand', 'العلامة التجارية'], price: ['Price', 'السعر'],
      mainCategories: ['Main Categories', 'الفئات الرئيسية'], categories: ['Categories', 'الفئات']
    };
    var pair = labels[filterKind(key)];
    return pair ? pair[ar ? 1 : 0] : key.replace(/\[\]$/, '').replace(/^pf_(?:[a-z]+_)?/i, '').replace(/_/g, ' ');
  }
  /* Repeated URL parameters are authoritative. A delimiter is only split when
     every part matches a checked native value, never by guessing at punctuation. */
  function parseFilters(href, selected) {
    var url = new URL(href), filters = [];
    Array.from(url.searchParams.entries()).forEach(function (entry, index) {
      var key = entry[0], value = entry[1];
      if (!isFilterKey(key) || !value.trim()) return;
      var known = (selected && selected[filterKind(key)]) || [];
      var exact = known.some(function (item) { return normalize(item) === normalize(value); });
      var separator = '';
      if (!exact && known.length > 1) {
        [',', '|'].some(function (candidate) {
          var parts = value.split(candidate);
          if (parts.length < 2 || !parts.every(function (part) {
            return part.trim() && known.some(function (item) { return normalize(item) === normalize(part); });
          })) return false;
          separator = candidate;
          return true;
        });
      }
      (separator ? value.split(separator) : [value]).forEach(function (part, partIndex) {
        filters.push({ key: key, value: part.trim(), raw: value, index: index, partIndex: partIndex, separator: separator });
      });
    });
    return filters;
  }

  function removalURL(href, filter) {
    var url = new URL(href), params = new URLSearchParams();
    Array.from(url.searchParams.entries()).forEach(function (entry, index) {
      if (entry[0] === 'page') return;
      if (index !== filter.index || entry[0] !== filter.key || entry[1] !== filter.raw) {
        params.append(entry[0], entry[1]);
        return;
      }
      if (filter.separator) {
        var parts = entry[1].split(filter.separator);
        parts.splice(filter.partIndex, 1);
        if (parts.length) params.append(entry[0], parts.join(filter.separator));
      }
    });
    /* A filter's AND modifier is no longer relevant after its last value is removed. */
    if (!params.has(filter.key)) {
      var modifier = filter.key.replace(/\[\]$/, '') + '_and_condition';
      params.delete(modifier);
      params.delete(modifier + '[]');
    }
    url.search = params.toString();
    return url.pathname + url.search + url.hash;
  }
  function clearURL(href) {
    var url = new URL(href), params = new URLSearchParams();
    url.searchParams.forEach(function (value, key) {
      if (!/^pf_/i.test(key) && key !== 'page') params.append(key, value);
    });
    url.search = params.toString();
    return url.pathname + url.search + url.hash;
  }

  /* Export pure URL functions solely for the local Node regression tests. */
  if (typeof module === 'object' && module.exports) {
    module.exports = { parseFilters: parseFilters, removalURL: removalURL, clearURL: clearURL };
    return;
  }

  function start() {
    var document = window.document;
    if (document.documentElement.hasAttribute('data-frame-filter-ux-ready')) return;
    var area = document.getElementById('MainContent');
    if (!area) return;
    document.documentElement.setAttribute('data-frame-filter-ux-ready', '');
    var bar = document.createElement('nav');
    bar.className = 'frame-filter-chips';
    var lastSignature = '', lastURL = '', pending = false;

    function getGroups() {
      return Array.from(document.querySelectorAll('.boost-sd__filter-option-title')).map(function (title) {
        var group = title, parent = title.parentElement;
        while (parent && parent !== document.body && parent.querySelectorAll('.boost-sd__filter-option-title').length === 1) {
          group = parent;
          parent = parent.parentElement;
        }
        return { node: group, kind: titleKind(title.textContent) };
      });
    }
    function getSelected(groups) {
      var selected = {};
      groups.forEach(function (group) {
        if (!group.kind) return;
        var values = selected[group.kind] || (selected[group.kind] = []);
        group.node.querySelectorAll('input[type="checkbox"]:checked, [role="checkbox"][aria-checked="true"]').forEach(function (control) {
          var row = control.closest('label,li,[role="checkbox"]') || control.parentElement;
          var label = row && row.querySelector('.boost-sd__filter-option-item-label');
          var value = label ? label.textContent : control.getAttribute('aria-label') || (control.value !== 'on' ? control.value : '') || control.textContent;
          if (value && !values.some(function (item) { return normalize(item) === normalize(value); })) values.push(value.trim());
        });
      });
      return selected;
    }
    function captureFocus() {
      var active = document.activeElement;
      if (!active || !bar.contains(active)) return null;
      var link = active.closest('a[data-frame-filter-action]');
      if (!link || !bar.contains(link)) return null;
      return {
        action: link.dataset.frameFilterAction,
        filter: link.dataset.frameFilter ? JSON.parse(link.dataset.frameFilter) : null,
        index: Array.from(bar.querySelectorAll('.frame-filter-chips__remove')).indexOf(link)
      };
    }
    function restoreFocus(state) {
      if (!state) return;
      var links = Array.from(bar.querySelectorAll('.frame-filter-chips__remove'));
      var clear = bar.querySelector('.frame-filter-chips__clear');
      var target = state.action === 'clear' ? clear : links.find(function (link) {
        var filter = JSON.parse(link.dataset.frameFilter);
        return filter.key === state.filter.key && filter.value === state.filter.value;
      });
      if (!target) target = links[Math.min(state.index, links.length - 1)] || clear || area.querySelector('.boost-sd__filter-tree-toggle-button');
      if (target && target.isConnected && target !== document.activeElement) target.focus({ preventScroll: true });
    }
    function render() {
      pending = false;
      /* Capture before hiding/replacing the bar; never take focus from outside it. */
      var focused = captureFocus();
      var groups = getGroups(), selected = getSelected(groups);
      var filters = parseFilters(window.location.href, selected);
      var ar = /^ar(?:-|$)/i.test(document.documentElement.lang);
      var toolbar = area.querySelector('.boost-sd__toolbar-container');
      if (toolbar && (bar.previousElementSibling !== toolbar || bar.parentElement !== toolbar.parentElement)) toolbar.after(bar);
      bar.hidden = !filters.length;
      bar.setAttribute('aria-label', ar ? 'الفلاتر النشطة' : 'Active filters');
      var signature = JSON.stringify([window.location.href, ar, filters]);
      lastURL = window.location.href;
      if (signature !== lastSignature) {
        lastSignature = signature;
        bar.replaceChildren();
        var list = document.createElement('ul');
        list.className = 'frame-filter-chips__list';
        filters.forEach(function (filter) {
          var item = document.createElement('li'), link = document.createElement('a');
          var label = labelFor(filter.key, ar) + ': ' + filter.value;
          link.className = 'frame-filter-chips__remove';
          link.href = removalURL(window.location.href, filter);
          link.dataset.frameFilterAction = 'remove';
          link.dataset.frameFilter = JSON.stringify(filter);
          link.setAttribute('aria-label', (ar ? 'إزالة ' : 'Remove ') + label);
          var text = document.createElement('span'), cross = document.createElement('span');
          text.dir = 'auto'; text.textContent = label;
          cross.setAttribute('aria-hidden', 'true'); cross.textContent = '×';
          link.append(text, cross); item.appendChild(link); list.appendChild(item);
        });
        bar.appendChild(list);
        if (filters.length) {
          var clear = document.createElement('a');
          clear.className = 'frame-filter-chips__clear';
          clear.href = clearURL(window.location.href);
          clear.dataset.frameFilterAction = 'clear';
          clear.textContent = ar ? 'مسح الكل' : 'Clear all';
          bar.appendChild(clear);
        }
      }
      restoreFocus(focused);
      area.querySelectorAll('.boost-sd__filter-tree-toggle-button-title').forEach(function (title) {
        var count = title.querySelector('.frame-filter-count');
        if (!count) { count = document.createElement('span'); count.className = 'frame-filter-count'; title.appendChild(count); }
        var value = filters.length ? ' (' + filters.length + ')' : '';
        if (count.textContent !== value) count.textContent = value;
      });
    }
    function schedule() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(render);
    }
    bar.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-frame-filter-action]');
      if (!link) return;
      if (link.dataset.frameFilterAction === 'clear') link.href = clearURL(window.location.href);
      else {
        var old = JSON.parse(link.dataset.frameFilter);
        var current = parseFilters(window.location.href, getSelected(getGroups())).find(function (filter) {
          return filter.key === old.key && filter.value === old.value;
        });
        /* Never remove an unrelated filter if Boost changed the URL just before a click. */
        if (!current) { event.preventDefault(); schedule(); return; }
        link.href = removalURL(window.location.href, current);
      }
      /* Standard same-origin anchor navigation is intentional: preserve all app
         state on reload without calling undocumented React internals. */
    });
    new window.MutationObserver(schedule).observe(document.body, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['aria-checked', 'checked']
    });
    window.addEventListener('popstate', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('hashchange', schedule);
    /* Boost changes history without emitting popstate; compare only the URL,
       and scan the DOM only after a real change or app mutation. */
    window.setInterval(function () {
      if (document.visibilityState !== 'hidden' && window.location.href !== lastURL) schedule();
    }, 500);
    render();
  }
  if (window.document.readyState === 'loading') window.document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})(typeof window !== 'undefined' ? window : null);
